import React from 'react'
import FundingContainer from './FundingContainer'

const Funding = () => <FundingContainer data-test="component-stock-funding" />

export default Funding
